import { useRef, useState } from "react";
import { useClickOutside } from "./useClickOutSide";

export const useCartBtn = () => {
  const [isCartOpen, setIsCartOpen] = useState(false);
  const cartRef = useRef<HTMLDivElement>(null);

  useClickOutside({
    ref: cartRef,
    onOutsideClick: () => setIsCartOpen(false),
  });

  return { isCartOpen, setIsCartOpen, cartRef };
};
